// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__Yr0s3","highlighted":"Tag_highlighted__SIdFm","water":"Tag_water__lRmDA","rotate":"Tag_rotate__bBIov","pulsate":"Tag_pulsate__gnN98"};